<template>
  <div>
    <validation-observer>
      <div class="row">
        <div
          :class="[
            'multiple-selection',
            orientation,
            'mt-3 col-12',
            {
              'col-lg-4': orientation === 'vertical',
            },
          ]"
        >
          <div
            class="options"
            :class="{ 'd-flex flex-wrap': orientation === 'horizontal' }"
          >
            <div
              v-for="(answerType, index) in input"
              :key="index"
              class="d-flex align-items-center mb-2"
              :class="{ 'mr-3': orientation === 'horizontal' }"
            >
              <div class="d-flex align-items-center">
                <input
                  class="large-checkbox"
                  :disabled="true"
                  type="checkbox"
                />
                <div class="ml-3 w-100">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-input
                      v-model="answerType.name"
                      custom-error-msg="El campo es requerido."
                      :error="errors[0]"
                    />
                  </validation-provider>
                </div>

                <div v-if="index > 1" class="ml-3">
                  <i
                    class="far fa-times-circle text-danger"
                    @click="triggerConfirmation(index)"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="canAddMore"
              class="d-flex align-items-center mb-2"
              :class="{ 'mr-3': orientation === 'horizontal' }"
            >
              <div class="d-flex align-items-center justify-content-start mt-2">
                <input
                  class="large-checkbox"
                  :disabled="true"
                  type="checkbox"
                />

                <div class="ml-3 w-100">
                  <u class="add-button" @click="addAnswerType">
                    Agregar una opción
                  </u>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import alertMixin from 'utils/mixins/alert.mixin';
export default {
  name: 'MultipleSelection',
  components: {
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    input: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    orientation: {
      type: String,
      default: 'vertical',
      validator: (value) => {
        return ['horizontal', 'vertical'].includes(value);
      },
    },
  },
  computed: {
    canAddMore() {
      return this.input.length < 5;
    },
  },
  async mounted() {
    if (this.input.length === 0) {
      this.input.push({ id: 1, name: '' }, { id: 2, name: '' });
    }
  },
  methods: {
    addAnswerType() {
      const newId = this.input.length + 1;
      this.input.push({ id: newId, name: '' });
    },
    removeAnswerType(index) {
      if (this.input.length > 2) {
        this.input.splice(index, 1);
      }
    },
    async triggerConfirmation(index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la sección documentada? `,
        'Si',
        'No'
      );
      if (!answer) return;
      this.removeAnswerType(index);
    },
  },
};
</script>

<style scoped>
.add-button {
  color: #2cb484;
  cursor: pointer;
  font-size: 16px;
}
.multiple-selection {
  .options {
    margin-bottom: 1rem;

    &.horizontal {
      display: flex;
      flex-wrap: wrap;
    }

    &.vertical {
      display: block;
    }

    .large-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 0.5rem;
      pointer-events: none;
    }
  }
}
</style>
